"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactScroll = require("react-scroll");

var _eyemobileCore = _interopRequireDefault(require("@bit/eyemobile.core.use-debounce"));

var _TabsHeader = _interopRequireDefault(require("./TabsHeader"));

var _Tabs = require("./Tabs.styles");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Tabs = function Tabs(_ref) {
  var headers = _ref.headers,
      children = _ref.children,
      onTabEnter = _ref.onTabEnter,
      onHeaderClick = _ref.onHeaderClick,
      containerId = _ref.containerId,
      headerId = _ref.headerId;
  var arrLength = headers.length;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var debouncedCurrentTab = (0, _eyemobileCore["default"])(currentTab, 1000);

  var handleHeaderClick = function handleHeaderClick(headerIndex) {
    return function (e) {
      if (onHeaderClick) {
        onHeaderClick(headerIndex);
      }
    };
  };

  var getRelativePos = function getRelativePos(el) {
    var pPos = el.parentNode.getBoundingClientRect(); // parent pos

    var cPos = el.getBoundingClientRect(); // target pos

    var pos = {
      top: cPos.top - pPos.top + el.parentNode.scrollTop,
      right: cPos.right - pPos.right,
      bottom: cPos.bottom - pPos.bottom,
      left: cPos.left - pPos.left,
      center: cPos.left - cPos.width - pPos.left
    };
    return pos;
  };

  var handleActiveTabFocus = function handleActiveTabFocus() {
    var activeTabEl = document.querySelectorAll("#".concat(headerId, " a"))[debouncedCurrentTab];
    var pos = getRelativePos(activeTabEl);
    activeTabEl.parentNode.scrollBy({
      left: pos.center,
      behavior: 'smooth'
    });
  };

  var handleCurrentTabChange = function handleCurrentTabChange(tabIndex) {
    return function () {
      if (onTabEnter) {
        onTabEnter(tabIndex);
      }

      setCurrentTab(tabIndex);
    };
  };

  (0, _react.useEffect)(function () {
    handleActiveTabFocus();
  }, [debouncedCurrentTab]);
  var panelsList = (0, _react.useMemo)(function () {
    return _react["default"].Children.map(children, function (child, index) {
      return (0, _core.jsx)(_reactScroll.Element, {
        name: "tab-".concat(index),
        style: {
          width: '100%'
        }
      }, (0, _core.jsx)(_Tabs.TabPanel, null, child));
    });
  }, [children]);
  return (0, _core.jsx)(_Tabs.TabsWrapper, null, arrLength > 0 && (0, _core.jsx)(_TabsHeader["default"], {
    headers: headers,
    onHeaderClick: handleHeaderClick,
    currentTab: currentTab,
    handleCurrentTabChange: handleCurrentTabChange,
    containerId: containerId
  }), (0, _core.jsx)(_Tabs.TabsPanels, null, panelsList));
};

Tabs.defaultProps = {
  headers: [],
  onTabEnter: null,
  onHeaderClick: null,
  containerId: undefined,
  headerId: 'tabs__header'
};
Tabs.propTypes = {
  headers: _propTypes["default"].array,
  onTabEnter: _propTypes["default"].func,
  onHeaderClick: _propTypes["default"].func,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  containerId: _propTypes["default"].string,
  headerId: _propTypes["default"].string
};
var _default = Tabs;
exports["default"] = _default;

//# sourceMappingURL=Tabs.js.map